<template>
    <edit></edit>
</template>

<script>
    import edit from './activity_secondkill_edit.vue'

    export default {
        name: 'activity_secondkill_add',

        components: {
            edit
        }
    }
</script>